import graphql from './graphql';

const query = /* GraphQL */ `
  query Priority_list {
    Priority_list {
      name
      id
    }
  }
`;

const priorityList = async () =>
  // eslint-disable-next-line camelcase
  graphql(query).then(({ Priority_list }) => Priority_list);

export default priorityList;
